import { Row } from "react-bootstrap";
import styled from "styled-components";

export const HeaderSection = styled(Row)`
  border-color: #eaeaea;
  position: relative;
  background: transparent;
  display: flex;
  justify-content: center;
  align-items: center;
  border: 0px;
`;